<template>
    <div v-wechat-title="title" class="padding10">
        <crud-facecade
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            :addButton="{ enabled: true, permission: 'default' }"
            :deleteButton="{ enabled: false, permission: 'default' }"
            :updateButton="{ enabled: false, permission: 'default' }"
            :tableHeight="tableHeight"
            @printbar="printbar"
        >
            <span slot="file_flag" @click="loadingInstructions(row)" class="cus-icon hoverspan" slot-scope="{ row }">
                <font-awesome-icon v-if="row.file_name" :icon="['fas', 'file-alt']"></font-awesome-icon>
            </span>
        </crud-facecade>
        <cus-dialog title="使用说明" :visible.sync="dialogVisible" width="80%" :close-on-click-modal="false" @confirm="dialogVisible = false">
            <div v-loading="loading" style="min-height: 580px">
                <pdf v-for="i in numPages" :key="i" :src="src" :page="i"></pdf>
            </div>
        </cus-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import pdf from '@/common/vue-pdf-4.1.0'
import printJs from 'print-js'
export default {
    name: `Device`,
    components: { pdf },
    props: {

    },
    data() {
        return {
            title: `基础数据-设备`,
            fileUploadConfig: this.$root.FileUploadConfig,
            currentid: undefined,
            dialogVisible: false,
            extensionsType: `.pdf`,
            numPages: 0,
            src: ``,
            loading: false,
            url: {
                baseURL: `/api/AcisSystem/Device`,
                get: () => { // 示例：支持返回promise
                    return new Promise((resolve) => {
                        let bed = this.myaxios.get(`/api/AcisSystem/RecoveryBed/Get`)
                        let room = this.myaxios.get(`/api/AcisSystem/OperatingRoom/Get`)
                        let device = this.myaxios.get(`/api/AcisSystem/Device/Get`)
                        axios.all(([device, room, bed])).then(axios.spread(function(device, room, bed) {
                            let dev = device.map(d => {
                                // if(d.dic_operating_room_id){
                                //   let r= _.find(room,{id:d.dic_operating_room_id})
                                //   d.wardId=r&&`o_${r.dic_operating_ward_id}`||undefined
                                // }else if(d.dic_recovery_bed_id){
                                //   let b= _.find(bed,{id:d.dic_recovery_bed_id})
                                //   d.ward_id=b&&`r_${b.dic_recovery_ward_id}
                                let filename = _.find(d.file_names, d => { return d.indexOf(`.pdf`) > -1 })
                                d.file_name = filename
                                d.ward_id = d.dic_operating_ward_id && `o_${d.dic_operating_ward_id}` || (d.dic_recovery_ward_id && `r_${d.dic_recovery_ward_id}`)
                                // d.room_bed =(d.dic_operating_room_id || d.dic_recovery_bed_id)
                                return d
                            })
                            resolve(dev)
                        }))
                    })
                },
                getOne: (row) => {
                    this.currentid = row.id
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/AcisSystem/Device/GetFileNames/${row.id}`)
                        req.then(data => {
                            let fs = _.groupBy(data, d3 => {
                                return d3.indexOf(`.pdf`) == -1 ? `image` : `pdf`
                            })
                            let r = { ...row }
                            r.instruction_file = fs && fs.pdf && fs.pdf.map(d => {
                                return {
                                    name: d,
                                    url: `${this.$root.BASE_URL}api/AcisSystem/Device/GetPdfFile/${row.id}?fileName=${d}`,
                                    uid: `f${row.id}`
                                }
                            }) || []
                            r.picture = fs && fs.image && fs.image.map(d => {
                                return {
                                    name: d,
                                    url: `${this.$root.BASE_URL}api/AcisSystem/Device/GetPictureFile/${row.id}?fileName=${d}`,
                                    uid: `p${row.id}`
                                }
                            }) || []
                            resolve(r)
                        })
                    })
                },
                put: (row) => {
                    let data = _.cloneDeep(row)
                    data.is_edit_valid = true
                    return this.myaxios.put(`/api/AcisSystem/Device/Put`, data)
                }
            },
            buttons: [{
                class: `is-plain`,
                label: `编辑`,
                type: `primary`,
                emit: `LoadingUpdateView`,
                permission: `default`
            }, {
                class: `is-plain`,
                label: `打印条码`,
                type: `primary`,
                emit: `printbar`,
                permission: `default`
            }]
        }
    },
    mounted() {
        this.$store.dispatch(`ADD_OPERATION_WARD_AUTH`)
        this.$store.dispatch(`ADD_RECOVERY_WARD_AUTH`)
    },
    computed: {
        ...mapGetters([`operation_ward_auth`, `recovery_ward_auth`, `operation_room_auth`, `recovery_bed_auth`, `sys_enums`, `screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        ward() {
            let ow = this[`operation_ward_auth`] && this[`operation_ward_auth`].map(ow => {
                return {
                    value: `o_${ow.value}`,
                    label: ow.label,
                    jianpin: ow.jianpin,
                    code: ow.code,
                    tag: `operation`,
                    rooms: ow.operation_room
                }// 手术区
            }) || []
            let rw = this[`recovery_ward_auth`] && this[`recovery_ward_auth`].map(rw => {
                return {
                    value: `r_${rw.value}`,
                    label: rw.label,
                    jianpin: rw.jianpin,
                    code: rw.code,
                    tag: `recovery`,
                    rooms: rw.recovery_bed
                }// 恢复区
            }) || []
            return ow.concat(rw)
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `number`,
                prop: `display_order`,
                label: `排序`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                readonly: false,
                sortable: true,
                isDisplayOrder: true
            }, {
                type: `string`,
                prop: `device_no`,
                label: `设备编号`,
                width: `180`,
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                searchable: false
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                validate: [{ max: 30, message: `设备名称长度不能大于30字节`, trigger: `blur` }, { required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `selectnotCode`,
                prop: `type_no`,
                label: `类型`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: this.sys_enums.Enum_PhysioParamCategory || [],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `dic_operating_room_id`
            }, {
                type: `string`,
                prop: `dic_recovery_bed_id`
            },
            {
                type: `string`,
                prop: `model`,
                label: `型号`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: false,
                sortable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            },
            {
                type: `string`,
                prop: `serial_number`,
                label: `序列号`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true
            },
            {
                type: `string`,
                prop: `bar_code`,
                label: `条码`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true
            },
            {// 辅助字段 用于创建和修改界面
                type: `select`,
                prop: `ward_id`,
                label: `所属区`,
                width: `180`,
                isListable: true,
                isCreatable: true,
                isEditable: true,
                options: this[`ward`],
                change: function(that, { row, column, area }) {
                    if (_.startsWith(row.ward_id, `o_`)) {
                        row.dic_operating_ward_id = row.ward_id.replace(`o_`, ``) * 1
                        row.dic_recovery_ward_id = 0
                    } else {
                        row.dic_operating_ward_id = 0
                        row.dic_recovery_ward_id = row.ward_id.replace(`r_`, ``) * 1
                    }
                },
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `device_no`,
                label: `网关床号`,
                isListable: true,
                isEditable: true,
                isCreatable: true
            }, {
                type: `string`,
                prop: `waveform_type`,
                label: `波形类型`,
                isListable: true,
                isEditable: true,
                isCreatable: true
            }, {
                type: `string`,
                prop: `vendor`,
                label: `厂商`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: false,
                sortable: false
            },
            {
                type: `custom`,
                prop: `file_flag`,
                label: `使用说明`,
                width: `60`,
                isListable: true,
                isExpand: false,
                isEditable: false,
                isCreatable: false
            }, {
                type: `date`,
                prop: `purchase_date`,
                label: `采购日期`,
                width: `120`,
                isListable: false,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: false,
                sortable: true
            }, {
                type: `string`,
                prop: `description`,
                label: `描述`,
                isListable: false,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: false,
                sortable: false
            }, {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `70`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: false,
                readonly: false,
                options: `is_enabled`,
                default: false
            }, {
                type: `select`,
                prop: `is_mobile`,
                label: `是否移动设备`,
                width: `120`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                sortable: true,
                options: `enum_bool`,
                default: false
            }, {
                type: `upload`,
                prop: `picture`,
                label: `实物图片`,
                isEditable: true,
                isCreatable: true,
                colspan: 24,
                options: (that, { row }) => {
                    return `${this.$root.BASE_URL}api/AcisSystem/Device/PostFiles/${row.origion.id}?extensionsType=ImageExtensions`
                },
                config: {
                    multipleLimit: 1,
                    accept: `image/jpeg`,
                    onExceed: (files, fileList) => {
                        this.$message.warning(`超过最大文件数`)
                    },
                    removeFile: (file, fileList) => {
                        let req = this.myaxios.delete(`/api/AcisSystem/Device/DeleteFile/${this.currentid}?fileName=${file.name}`)
                        req.then(data => {})
                    },
                    beforeUpload: (file) => {
                        let fileconfig = JSON.parse(this.fileUploadConfig)
                        let extensions = fileconfig && fileconfig.ImageExtensions ? fileconfig.ImageExtensions.split(`,`) : []
                        let maxSize = Number(fileconfig.MaxSize) * 1024 * 1024

                        if (!(file.size < maxSize)) {
                            this.$message.error(`上传文件大小大小不能超过[${fileconfig.MaxSize}]MB!`)
                            return false
                        }
                        let filetype = file.name.split(`.`).slice(-1)[0].toLowerCase()
                        if (!_.includes(extensions, `.` + filetype)) {
                            this.$message.error(`上传文件只能是[${fileconfig.ImageExtensions}]格式!`)
                            return false
                        }
                    }
                }
            }, {
                type: `upload`,
                prop: `instruction_file`,
                label: `说明文件`,
                isEditable: true,
                isCreatable: true,
                placeholder: `只能上传pdf文件`,
                colspan: 24,
                options: (that, { row }) => {
                    return `${this.$root.BASE_URL}api/AcisSystem/Device/PostFiles/${row.origion.id}?extensionsType=${this.extensionsType}`
                },
                config: {
                    listType: ``,
                    multipleLimit: 1,
                    accept: `application/pdf`,
                    onExceed: (files, fileList) => {
                        this.$message.warning(`超过最大文件数`)
                    },
                    removeFile: (file, fileList) => {
                        let req = this.myaxios.delete(`/api/AcisSystem/Device/DeleteFile/${this.currentid}?fileName=${file.name}`)
                        req.then(data => {})
                    },
                    beforeUpload: (file) => {
                        let fileconfig = JSON.parse(this.fileUploadConfig)
                        // let extensions = fileconfig && fileconfig.ImageExtensions ? fileconfig.ImageExtensions.split(`,`) : []
                        let maxSize = Number(fileconfig.MaxSize) * 1024 * 1024

                        if (!(file.size < maxSize)) {
                            this.$message.error(`上传文件大小大小不能超过[${fileconfig.MaxSize}]MB!`)
                            return false
                        }
                        let filetype = file.name.split(`.`).slice(-1)[0].toLowerCase()
                        if (filetype != `pdf`) {
                            this.$message.error(`上传文件只能是[pdf]格式!`)
                            return false
                        }
                    }
                }
            }]
        }
    },
    methods: {
        loadingInstructions(row) {
            let req = this.myaxios.get(`/api/AcisSystem/Device/GetFileNames/${row.id}`)
            req.then(data => {
                let file = _.find(data, d => { return d.indexOf(`.pdf`) > -1 })
                if (file) {
                    this.loading = true
                    this.dialogVisible = true
                    this.numPages = 0
                    this.src = ``
                    let req2 = axios.get(`${this.$root.BASE_URL}api/AcisSystem/Device/GetPdfFile/${row.id}?fileName=${file}`)
                    req2.then(data2 => {
                        this.src = pdf.createLoadingTask(`data:application/pdf;base64,${data2}`)
                        this.src.then(content => {
                            this.numPages = content.numPages
                            this.loading = false
                        })
                    })
                } else {
                    this.$message.warning(`暂无使用说明`)
                }
            })
        },
        printbar({ row }) {
            let req = this.myaxios.get(`/api/AcisSystem/Device/CreateBarcode/${row.id}`)
            req.then(data => {
                printJs({ printable: `data:image/jpeg;base64,` + data, type: `image`, base64: true, maxWidth: 1500 })
            })
        }
    }
}
</script>
<style scoped>
.hoverspan {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Device/Index.vue